import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import theme from "./theme";
import { PRIMARY_COLOR } from "./consts";

// Barlow font - all available weights
import "@fontsource/barlow/100.css";
import "@fontsource/barlow/200.css";
import "@fontsource/barlow/300.css";
import "@fontsource/barlow/400.css";
import "@fontsource/barlow/500.css";
import "@fontsource/barlow/600.css";
import "@fontsource/barlow/700.css";
import "@fontsource/barlow/800.css";
import "@fontsource/barlow/900.css";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          "::selection": {
            backgroundColor: PRIMARY_COLOR,
            color: "#ffffff",
          },
          "::-moz-selection": {
            backgroundColor: PRIMARY_COLOR,
            color: "#ffffff",
          },
        }}
      />
      {children}
    </MuiThemeProvider>
  );
}

export default ThemeProvider;
